const mailing = {
    date: '',
    subject: '',
    type: 'custom',
    text: '',
    sent_to_all: true,
};

export default mailing
